import { FC } from 'react'
import { DataTransContainer } from './styled'
import * as Sentry from '@sentry/react'
import { DatatransLightbox } from './DatatransLightbox'

type DataTransProps = {
  transactionId: string
}

export const DataTrans: FC<DataTransProps> = ({ transactionId }) => {
  const onError = (data: any): void => {
    console.log('@DataTrans. Error:', data)
    Sentry.captureException(
      data instanceof Error ? data : new Error('Datatrans lightbox error'),
      { tags: { method: 'datatrans', transactionId }, extra: { data } }
    )
  }

  return (
    <DataTransContainer data-testid="data-trans_test-id">
      <DatatransLightbox
        onError={onError}
        transactionId={transactionId}
        production={process.env.REACT_APP_IS_PROD === '1'}
      />
    </DataTransContainer>
  )
}
